import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'ngx-header-clear',
  styleUrls: ['./header-clear.component.scss'],
  templateUrl: './header-clear.component.html',
})
export class HeaderClearComponent implements OnInit {


  @Input() position = 'normal';

  user: any;

  //userMenu = [{ title: 'Minha conta' }, { title: 'Sair', link: '/auth/logout' }];
  userMenu = [];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserService,
              private analyticsService: AnalyticsService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.user = this.authService.getUser();
    //this.userService.getUsers().subscribe((users: any) => this.user = users.default);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }
}



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/@theme/components/header-clear/header-clear.component.ts